import { Trans } from "@lingui/react/macro"
import { NavigationTrigger } from "@rarible_int/anaconda_ui_components"

import type { BlockchainFilter } from "@/app/blockchains/filters/blockchain-filters-scope"
import { NavigationTabsList } from "@rarible_int/anaconda_ui_components"
import Link from "next/link"
import { usePathname } from "next/navigation"

interface Props {
  blockchain?: BlockchainFilter
}

export function DropsNavigation({ blockchain }: Props) {
  const pathname = usePathname()
  const blockchainLowerCase = blockchain?.toLowerCase()
  const isPastPage = pathname === `/${blockchainLowerCase}/drops/past`

  return (
    <NavigationTabsList size="lg" data-testid="drops-navigation">
      <NavigationTrigger
        active={!isPastPage}
        className="text-xl"
        disabled={!blockchainLowerCase}
      >
        <Link href={`/${blockchainLowerCase}/drops`}>
          <h4>
            <Trans>Live & Upcoming</Trans>
          </h4>
        </Link>
      </NavigationTrigger>
      <NavigationTrigger
        active={isPastPage}
        className="text-xl"
        disabled={!blockchainLowerCase}
      >
        <Link href={`/${blockchainLowerCase}/drops/past`}>
          <h4>
            <Trans>Past</Trans>
          </h4>
        </Link>
      </NavigationTrigger>
    </NavigationTabsList>
  )
}
